import React from "react";
import { CheckCircle2, Mail } from "lucide-react";
import { Issue } from "src/types";
import { NoteDisplay } from "src/components";

interface IssueDetailsSectionProps extends Issue {}

const IssueDetailsSection: React.FC<IssueDetailsSectionProps> = ({ status, resolutionDetails, resolvedByEmail }) => {
  if ((status !== "Resolved" && status !== "Closed") || !resolutionDetails) {
    return null;
  }

  return (
    <div className="border border-neutral-200 rounded-2xl p-5 bg-white">
      <h3 className="text-sm font-semibold text-black mb-4 tracking-wide uppercase flex items-center">
        <CheckCircle2 className="w-4 h-4 mr-2" />
        Resolution Details
      </h3>
      <div className="space-y-4">
        <NoteDisplay note={{ body: resolutionDetails, date: "" }} />
        {resolvedByEmail && (
          <div className="flex items-center text-sm text-gray-700">
            <Mail className="w-4 h-4 mr-2" />
            <span>
              <span className="font-medium">Resolved By:</span> {resolvedByEmail}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export { IssueDetailsSection };
